type Employee = {
  name: string
  i18nTitleKey: string
  i18nResumeeKey: string
  linkedinUrl?: string
}

const BASE_I18N_KEY = 'team:teamMembers'

export const EMPLOYEES: Employee[] = [
  {
    name: 'Marion de Meslon',
    i18nTitleKey: `${BASE_I18N_KEY}.marion.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.marion.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/marion-de-meslon/'
  },
  {
    name: 'Alexis Fontant',
    i18nTitleKey: `${BASE_I18N_KEY}.alexis.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.alexis.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/alexis-fontant-11a66843/'
  },
  {
    name: 'Alice Conques',
    i18nTitleKey: `${BASE_I18N_KEY}.alice.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.alice.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/alice-conques/'
  },
  {
    name: 'Fabrice Bonan',
    i18nTitleKey: `${BASE_I18N_KEY}.fabrice.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.fabrice.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/fabrice-bonan-894a0613/'
  },
  {
    name: 'Wilfried de Kerchove',
    i18nTitleKey: `${BASE_I18N_KEY}.wilfried.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.wilfried.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/wdkdd/'
  },
  {
    name: 'Claude Dalle',
    i18nTitleKey: `${BASE_I18N_KEY}.claude.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.claude.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/claude-dalle-18a84313/'
  },
  {
    name: 'Alexandre Hollard',
    i18nTitleKey: `${BASE_I18N_KEY}.alexandre.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.alexandre.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/alexandre-hollard/'
  },
  {
    name: 'Antoine Attali',
    i18nTitleKey: `${BASE_I18N_KEY}.antoine.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.antoine.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/antoine-attali/'
  },
  {
    name: 'Ismaël Émélien',
    i18nTitleKey: `${BASE_I18N_KEY}.ismael.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.ismael.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/isma%C3%ABl-emelien-a0286922b/'
  },
  {
    name: 'Paul Dupuy',
    i18nTitleKey: `${BASE_I18N_KEY}.paul.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.paul.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/pauldupuy89/'
  },
  {
    name: 'Tyra Malzy',
    i18nTitleKey: `${BASE_I18N_KEY}.tyra.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.tyra.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/tyramalzy/'
  },
  {
    name: 'Dom Leca',
    i18nTitleKey: `${BASE_I18N_KEY}.dom.title`,
    i18nResumeeKey: `${BASE_I18N_KEY}.dom.resumee`,
    linkedinUrl: 'https://www.linkedin.com/in/dominiqueleca/'
  }
]
